import React from 'react';
import { Container, List, Heading, RichText } from './StyledAccordion';
import AccordionItem from './AccordionItem';
import { withEditMode, withEditModeNotice } from '_containers/BaseComponent';
import { compose } from 'ramda';
import { warnInDev } from '_utils/helpers/dev';
import PropTypes from 'prop-types';

const ContainerWithNotice = withEditModeNotice(Container);

const HeadingWithDescription = (props) => {

  let { headingField, descriptionField, headingLevel } = props;

  headingLevel = headingLevel?.value || 'h2';

  return (
    <Container>
      {headingField && (
        <Heading
          tag={typeof headingLevel === 'number' ? `h${headingLevel}` : headingLevel}
          field={headingField}
        />
      )}
      {descriptionField && <RichText field={descriptionField} />}
    </Container>
  );
};

HeadingWithDescription.propTypes = {
  headingField: PropTypes.object,
  descriptionField: PropTypes.object,
  headingLevel: PropTypes.oneOfType([
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    PropTypes.string,
    PropTypes.number
  ])
};

export type AccordionItemData = {
  content: {
    data: any;
  };
  title: {
    data: any;
  };
  showExpanded: {
    data: any;
  }
};

const isValidAccordionItem = (item) => {
  if (!item) {
    return false;
  }
  const { title, content } = item;
  return !!title?.data?.value && !!content?.data?.value;
};

function Accordion({ editMode, rendering }) {
  let items: AccordionItemData[] = rendering?.fields?.data?.datasource?.accordion;
  const heading = rendering?.fields?.data?.datasource?.heading?.jss;
  const headingLevel = rendering?.fields?.data?.datasource?.headingLevel?.jss;
  const description = rendering?.fields?.data?.datasource?.description?.jss;
  const subheadingLevel = rendering?.params?.headingLevel || 'h2';

  if (!editMode) {
    items = items?.filter((item) => isValidAccordionItem(item)) || [];
  }

  if (!editMode && !items.length) {
    warnInDev('Accordion has no valid items');
    return null;
  }

  let noticeMessage = null;

  if (editMode) {
    const hasValidItems = items?.filter((item) => isValidAccordionItem(item)).length > 0 || false;

    if (!items) {
      noticeMessage = 'Accordion component has no data source';
    }

    if (!hasValidItems) {
      noticeMessage = 'Accordion component has no valid items and will not be displayed.';
    }
  }

  return (
    <ContainerWithNotice
      noticeEnabled={noticeMessage !== null}
      noticeLevel="warning"
      noticeMessage={noticeMessage}
    >
      {Boolean(heading || description) && (
        <HeadingWithDescription
          headingField={heading}
          descriptionField={description}
          headingLevel={headingLevel}
        />
      )}
      <List>
      {items?.map((item, index) => (
        /* TODO better key from sitecore */
        <AccordionItem key={index} item={item} headingLevel={subheadingLevel} />
      ))}
      </List>
    </ContainerWithNotice>
  );
}

Accordion.propTypes = {
  editMode: PropTypes.bool,
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      data: PropTypes.shape({
        datasource: PropTypes.shape({
          accordion: PropTypes.arrayOf(
            PropTypes.shape({
              content: PropTypes.shape({
                data: PropTypes.any
              }),
              title: PropTypes.shape({
                data: PropTypes.any
              }),
              showExpanded: PropTypes.shape({
                data: PropTypes.any
              })
            })
          ),
          heading: PropTypes.shape({
            jss: PropTypes.any
          }),
          headingLevel: PropTypes.shape({
            jss: PropTypes.any
          }),
          description: PropTypes.shape({
            jss: PropTypes.any
          })
        })
      })
    }),
    params: PropTypes.shape({
      headingLevel: PropTypes.string
    })
  })
};

export default compose(withEditMode)(Accordion);
